module.exports = __webpack_public_path__ + "img/step_one.ac53a6f1.png";